module.exports = __webpack_public_path__ + "static/img/genkin_administration.11d147bf.svg";